const XPPlatform = {
  OS: "web",
  select: obj => obj.web
};
export { XPPlatform };
//# sourceMappingURL=XPPlatform.mjs.map
